/* Earthle: muted video starts only in view, never inside a closed accordion.
   Individual players retain their own manual pause and reduced-motion state. */
(function () {
  if (window.EarthleVideoVisibility) return;
  var players = new Map();
  var scheduled = false;

  function isVisible(video) {
    if (document.hidden || !video.isConnected) return false;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    var left = Math.max(0, rect.left), right = Math.min(innerWidth, rect.right);
    var top = Math.max(0, rect.top), bottom = Math.min(innerHeight, rect.bottom);
    for (var el = video; el; el = el.parentElement) {
      if (el.hidden || (el.tagName === 'DETAILS' && !el.open)) return false;
      var css = getComputedStyle(el);
      if (css.display === 'none' || css.visibility === 'hidden' || css.visibility === 'collapse' || Number(css.opacity) === 0) return false;
      if (el !== video && /hidden|clip|scroll|auto/.test(css.overflowX + css.overflowY)) {
        var clip = el.getBoundingClientRect();
        if (/hidden|clip|scroll|auto/.test(css.overflowX)) {
          left = Math.max(left, clip.left); right = Math.min(right, clip.right);
        }
        if (/hidden|clip|scroll|auto/.test(css.overflowY)) {
          top = Math.max(top, clip.top); bottom = Math.min(bottom, clip.bottom);
        }
      }
    }
    return Math.max(0, right - left) * Math.max(0, bottom - top) >= rect.width * rect.height * 0.25;
  }

  function update() {
    scheduled = false;
    players.forEach(function (state, video) {
      if (!video.isConnected) {
        video.pause();
        if (observer) observer.unobserve(video);
        players.delete(video);
        return;
      }
      var visible = isVisible(video);
      if (!visible) video.pause();
      else if (!state.visible) state.play();
      state.visible = visible;
    });
  }

  function refresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  var observer = window.IntersectionObserver ? new IntersectionObserver(refresh, { threshold: [0, 0.25, 1] }) : null;

  function register(video, play) {
    if (players.has(video)) return;
    video.setAttribute('data-visible-video', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.pause();
    // Legacy article HTML may already have requested autoplay before registration.
    try { video.currentTime = 0; } catch (e) { /* Not loaded yet: already at zero. */ }
    var state = { visible: false, play: play };
    players.set(video, state);
    video.addEventListener('play', function () {
      if (!isVisible(video)) video.pause();
    });
    video.addEventListener('loadeddata', function () {
      if (isVisible(video)) play();
      else video.pause();
    });
    if (observer) observer.observe(video);
    refresh();
  }

  window.EarthleVideoVisibility = { register: register, isVisible: isVisible, refresh: refresh };
  document.addEventListener('scroll', refresh, { capture: true, passive: true });
  document.addEventListener('toggle', refresh, true);
  // Reveal animations can change ancestor opacity after the intersection event.
  document.addEventListener('transitionend', refresh, true);
  document.addEventListener('animationend', refresh, true);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', refresh);
})();
